import {
  AccountListItem,
  LoadingListItem,
  PercentChip,
  UnknownBeneficiaryListItem,
} from '@razz-team/ui-web';
import { ApiAccount, ApiBeneficiary, ApiStandingOrderDestination } from '../../../openapi';
import { BeneficiaryListItem } from '../../ListItem/BeneficiaryListItem';
import { useMemo } from 'react';

export function StandingOrderDestinationListItem({
  destination,
  accounts,
  beneficiaries,
  onDelete,
}: {
  destination: ApiStandingOrderDestination;
  accounts: ApiAccount[];
  beneficiaries: ApiBeneficiary[];
  onDelete?: (destination: ApiStandingOrderDestination) => void;
}) {
  const handleDelete = useMemo(
    () => (onDelete ? () => onDelete(destination) : undefined),
    [onDelete, destination],
  );
  const secondaryAction = <PercentChip value={destination.ratio} onDelete={handleDelete} />;

  switch (destination.type) {
    case 'OwnAccount': {
      const account = accounts.find((a) => a.id === destination.accountId);
      if (!account) {
        return <LoadingListItem secondaryAction={secondaryAction} />;
      }
      return <AccountListItem account={account} secondaryAction={secondaryAction} />;
    }
    case 'External': {
      const beneficiary = beneficiaries.find((b) => b.beneficiaryId === destination.beneficiaryId);
      if (!beneficiary) {
        return <LoadingListItem secondaryAction={secondaryAction} />;
      }
      return <BeneficiaryListItem beneficiary={beneficiary} secondaryAction={secondaryAction} />;
    }
    default:
      return <UnknownBeneficiaryListItem secondaryAction={secondaryAction} />;
  }
}
